import { useEventBus } from '@vueuse/core'

export const busKey = Symbol('tab-setting')
export const openBus = useEventBus(busKey)